import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        navigationLogin: {
            textParagraph: 'Dont have an account?',
            textButton: 'Signup',
            href: '/signup'
        },
        formLogin: {
            textHeadingOne: 'Login',
            textParagraph: 'Enter your details below',
            email: 'Email address',
            errorMessageEmail: 'Invalid email',
            password: 'Password',
            errorMessagePassword: 'Invalid password',
            forgotPassword: 'Forgot password?',
            forgotPasswordHref: '/passwordreset',
            formButtonText: 'Login',
						formButtonClassType: 'btn--fullWidth',
						noAccount:'Dont have an account yet?  <a class="textAnchor color-primary" href="/signup">Sign up</a>'

        }
    },
    es: {
        navigationLogin: {
            textParagraph: 'No tienes cuenta?',
            textButton: 'Regístrate',
            href: '/signup'
        },
        formSignUp: {
            textHeadingOne: 'Empieza ahora totalmente gratis.',
            textParagraph: 'Construye un chatbot para tu página de Facebook fácil y rápido',
            fullName: 'Nombre completo',
            errorMessageFullName: 'Nombre inválido',
            email: 'Correo',
            errorMessageEmail: 'Correo inválido',
            password: 'Contraseña',
            errorMessagePassword: 'Contraseña incorrecta',
            verifyPassword: 'Verifica tu contraseña',
            errorMessageVerifyPassword: 'Contraseña inválida',
            formButtonText: 'Crea una cuenta'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/pages/Login/LoginContent.js